__turbopack_context__.v({
  "M": "tag-module-scss-module__MCNiFq__M",
  "S": "tag-module-scss-module__MCNiFq__S",
  "app_light_theme": "tag-module-scss-module__MCNiFq__app_light_theme",
  "bottom": "tag-module-scss-module__MCNiFq__bottom",
  "modal": "tag-module-scss-module__MCNiFq__modal",
  "root": "tag-module-scss-module__MCNiFq__root",
  "tag": "tag-module-scss-module__MCNiFq__tag",
  "tagPopover": "tag-module-scss-module__MCNiFq__tagPopover",
  "tagShortName": "tag-module-scss-module__MCNiFq__tagShortName",
  "timer": "tag-module-scss-module__MCNiFq__timer",
  "timerBlink": "tag-module-scss-module__MCNiFq__timerBlink",
});
